module.exports = __webpack_public_path__ + "static/media/Minus-red.8fd88be0.svg";